import { Ref } from "vue";
import { Key } from "../../../../../types/skyward/svg";
import Button from "../../../../core/button";

export const isSmallScreen = (): boolean => window.innerWidth < 1024;

export const Classes =
{
    JobPostingSortSvg: "jobPostingSortSvg",
    JobPostingColumnDiv: "jobPostingColumnDiv",
    JobPostingColumnSpan: "jobPostingColumnSpan",
    DisplayNone: "displayNone",
}

export function getButton(text: string,
    iconName: Key,
    clickAction: Function,
    options: {  // Type definition
        reference?: Ref<typeof Button | undefined>,
        visible?: boolean,
        disabled?: boolean,
        spanClass?: string,
        buttonClass?: string
    }): JSX.Element
{
    let opts = {  // Defaults
        reference: options.reference,
        visible: options.visible ?? true,
        disabled: options.disabled ?? false,
        spanClass: options.spanClass ?? "",
        buttonClass: options.buttonClass ?? "",
    };
    return (
        <Button ref={opts.reference}
                spanClasses={["jobPostingButton", opts.spanClass]}
                class={{ [Classes.DisplayNone]: !(opts.visible), "ui-disabled": opts.disabled, [opts.buttonClass]: true }}
                svgName={ iconName }
                clickFunc={(_event: MouseEvent) => { if (!opts.disabled) clickAction(); }}>{text}</Button>)
}
